import React from 'react'

export const IconDefaultPoint = () => {
  return (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.82227 0.5C13.2466 0.5 16.8221 4.13255 16.8223 8.59961C16.8223 9.77864 16.3028 11.1077 15.5879 12.3945C14.8656 13.6945 13.9087 15.0133 12.9619 16.1875C12.0135 17.3636 11.0657 18.406 10.3564 19.1533C10.0016 19.5271 9.70574 19.8284 9.49805 20.0361C9.39427 20.1399 9.31196 20.2205 9.25586 20.2754C9.2279 20.3028 9.20613 20.3236 9.19141 20.3379L9.16895 20.3604L8.82227 20.6934L8.47559 20.3604L8.45312 20.3379C8.4384 20.3236 8.41663 20.3028 8.38867 20.2754C8.33257 20.2205 8.25027 20.1399 8.14648 20.0361C7.93879 19.8284 7.64289 19.5271 7.28809 19.1533C6.5788 18.406 5.63098 17.3636 4.68262 16.1875C3.73587 15.0133 2.77892 13.6945 2.05664 12.3945C1.34169 11.1077 0.822266 9.77864 0.822266 8.59961C0.822474 4.13255 4.39789 0.5 8.82227 0.5Z"
        fill="#66CFC3"
        stroke="white"
      />
      <path
        d="M8.82227 1.5C12.6819 1.5 15.8221 4.6723 15.8223 8.59961C15.8223 9.51913 15.4041 10.6652 14.7129 11.9092C14.029 13.14 13.1107 14.4095 12.1826 15.5605C11.2562 16.7095 10.3287 17.7306 9.63184 18.4648C9.30136 18.813 9.02276 19.0958 8.82227 19.2969C8.62177 19.0958 8.34317 18.813 8.0127 18.4648C7.31583 17.7306 6.38837 16.7095 5.46191 15.5605C4.53382 14.4095 3.61551 13.14 2.93164 11.9092C2.24046 10.6652 1.82227 9.51913 1.82227 8.59961C1.82247 4.6723 4.96262 1.5 8.82227 1.5Z"
        fill="#66CFC3"
        stroke="#228E82"
      />
    </svg>
  )
}
